import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Network, Search, X } from "lucide-react";
import { AppDispatch, RootState } from "../../../../../store";
import { getReferralNetworkMilestoneMembers } from "../../../../../Redux/referral/slice";
import { formatEarningsCurrency } from "../../earningsAdapters";
import Pagenation from "../../../../../ecommerce/globalcomponents/pagenation/Pagenation";
import ReferralCommLevelTable from "./ReferralCommLevelTable";
import "../SalarFlowPage.css";

const ReferralCommLevel = () => {
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderNo = queryParams.get("orderNo") || "";
  const milestoneNo = parseInt(queryParams.get("milestoneNo") || "1");

  const { referralNetworkMilestoneMembers } = useSelector(
    (state: RootState) => state.referral,
  );

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    if (orderNo) {
      dispatch(
        getReferralNetworkMilestoneMembers({
          orderNo,
          milestoneNo,
          page,
          limit,
          status: "ALL",
          sortOrder: "ASC",
          search: debouncedSearch || undefined,
        }),
      );
    }
  }, [dispatch, orderNo, milestoneNo, page, limit, debouncedSearch]);

  const { milestone, members, pagination } = referralNetworkMilestoneMembers;
  const milestoneName = milestone
    ? `Milestone ${milestone.milestoneNo}`
    : `Milestone - ${milestoneNo}`;

  return (
    <section className="ri-page ri-milestone-page">
      <div className="ri-shell">
        <header className="ri-page-header">
          <div className="ri-page-title">
            <span className="ri-title-icon">
              <Network size={25} />
            </span>
            <div>
              <span className="ri-eyebrow">SALAR FLOW MILESTONE</span>
              <h1>Salar Flow Network : {milestoneName}</h1>
              <p>
                Order {orderNo} · Partner-network and received incentive
                details for this milestone.
              </p>
              {milestone?.tds && (
                <p>
                  TDS {milestone.tds.tdsPercentage}% applied on Salar Flow
                  incentives
                  {milestone.tds.hasPanCard === false && " (No PAN on KYC)"}
                  {" · "}
                  Total TDS {formatEarningsCurrency(milestone.tds.totalSalarFlowTds)}
                  {" · "}Net {formatEarningsCurrency(milestone.tds.totalSalarFlowNet)}
                </p>
              )}
            </div>
          </div>
          <div className="ri-header-actions">
            <div className="ri-search ri-header-search">
              <Search size={19} />
              <input
                type="search"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(1);
                }}
                placeholder="Search members..."
                aria-label="Search members"
              />
              {search && (
                <button
                  type="button"
                  onClick={() => setSearch("")}
                  aria-label="Clear search"
                >
                  <X size={16} />
                </button>
              )}
            </div>
          </div>
        </header>

        <div className="ri-toolbar">
          <select
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setPage(1);
            }}
            aria-label="Entries per page"
          >
            {[10, 25, 50, 75, 100].map((val) => (
              <option value={val} key={val}>
                {val} Entries
              </option>
            ))}
          </select>
        </div>

        <ReferralCommLevelTable members={members || []} />

        <Pagenation
          currentPage={page}
          totalPages={pagination?.totalPages || 0}
          onPageChange={setPage}
        />
      </div>
    </section>
  );
};

export default ReferralCommLevel;
